/* eslint-disable no-new */
/* eslint-disable vue/one-component-per-file */
import '../scss/skogsskolan.scss'
import { createApp, defineAsyncComponent } from 'vue'
import { OnPageNav } from './components/_onpage-nav.js'
import { mailLinks } from './components/mail-links.js'
import 'bootstrap'

const pageInit = () => {
    mailLinks()
    if (document.getElementById('mobilenav')) {
        const NavigationComp = defineAsyncComponent(() => import(/* webpackChunkName: "navigation" */ './vue/components/_navigation.vue'))
        const app = createApp({
            components: {
                'v-comp': NavigationComp
            }
        })
        app.mount('#mobilenav')
    }

    const coursemodules = document.querySelectorAll('.course-module')

    if (coursemodules?.length) {
        const CourseModule = defineAsyncComponent(() => import(/* webpackChunkName: "coursemodule" */ './vue/components/course/_coursemodule.vue'))

        coursemodules.forEach(el => {
            const app = createApp({
                components: {
                    'v-comp': CourseModule
                }
            })
            app.mount(`#${el.id}`)
        })
    }

    if (document.querySelector('.splide--events')) {
        import(/* webpackChunkName: "event-slider" */ './components/_event-slider').then(module => {
            module.eventSlider()
        })
    }
    const videos = document.querySelectorAll('.video')

    if (videos?.length) {
        const Video = defineAsyncComponent(() => import(/* webpackChunkName: "video" */ './vue/components/video/_video.vue'))

        videos.forEach(el => {
            const app = createApp({
                components: {
                    'v-comp': Video
                }
            })
            app.mount(`#${el.id}`)
        })
    }

    const eventsCarousels = document.querySelectorAll('.events-carousel')

    if (eventsCarousels?.length) {
        const EventsCarousel = defineAsyncComponent(() => import(/* webpackChunkName: "eventscarousel" */ './vue/components/carousels/_eventscarousel.vue'))

        eventsCarousels.forEach(el => {
            const app = createApp({
                components: {
                    'v-comp': EventsCarousel
                }
            })
            app.mount(`#${el.id}`)
        })
    }
    const accordions = document.querySelectorAll('.accordion')

    if (accordions?.length) {
        const Accordion = defineAsyncComponent(() => import(/* webpackChunkName: "faqlist" */ './vue/components/faq/_faqlist.vue'))

        accordions.forEach(el => {
            const app = createApp({
                components: {
                    'v-comp': Accordion
                }
            })
            app.mount(`#${el.id}`)
        })
    }

    const documntLibrarys = document.querySelectorAll('.document-library')

    if (documntLibrarys?.length) {
        const DocumentLibrary = defineAsyncComponent(() => import(/* webpackChunkName: "documentlibrary" */ './vue/components/documentlibrary/_documentlibrary.vue'))

        documntLibrarys.forEach(el => {
            const app = createApp({
                components: {
                    'v-comp': DocumentLibrary
                }
            })
            app.mount(`#${el.id}`)
        })
    }

    new OnPageNav()
}

const pageLoad = () => {
    if (document.getElementById('courseListing')) {
        const CourseListing = defineAsyncComponent(() => import(/* webpackChunkName: "courseListing" */ './vue/components/course/_courselisting.vue'))
        const app = createApp({
            components: {
                'v-comp': CourseListing
            }
        })
        app.mount('#courseListing')
    }

    if (document.getElementById('imageLibrary')) {
        const ImageLibrary = defineAsyncComponent(() => import(/* webpackChunkName: "imagelibrary" */ './vue/components/imagelibrary/_imagelibrary.vue'))
        const app = createApp({
            components: {
                'v-comp': ImageLibrary
            }
        })
        app.mount('#imageLibrary')
    }

    if (document.getElementById('faqList')) {
        const FaqList = defineAsyncComponent(() => import(/* webpackChunkName: "faqlist" */ './vue/components/faq/_faqlist.vue'))
        const app = createApp({
            components: {
                'v-comp': FaqList
            }
        })
        app.mount('#faqList')
    }
}

pageInit()
window.addEventListener('load', pageLoad)
